import { useState, useCallback, useEffect } from 'react'

const STORAGE_KEY = 'vosci_admin_presentation_mode'

export function usePresentationMode() {
  const [presenting, setPresenting] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true'
    } catch {
      return true // default to presenting (safe)
    }
  })

  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, String(presenting))
    } catch {
      // ignore
    }
  }, [presenting])

  const toggle = useCallback(() => setPresenting((p) => !p), [])

  return { presenting, toggle }
}
